import { useContext, useEffect, useState } from 'react';
import api from '../api';
import { UserContext } from '../context/UserContext';
import './home.css';

export default function MentorAssignments() {
  const { user } = useContext(UserContext);
  const [data, setData] = useState({ trainees: [], mentors: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedTrainee, setSelectedTrainee] = useState(null);
  const [selectedMentorId, setSelectedMentorId] = useState('');
  const [forceAssign, setForceAssign] = useState(false);
  const [expandedMentors, setExpandedMentors] = useState({});
  const isPrivileged = Array.isArray(user?.roles) && (user.roles.includes('admin') || user.roles.includes('owner') || user.roles.includes('moderator'));

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get('/admin/mentor-mappings');
      setData(res.data || { trainees: [], mentors: [] });
    } catch (e) {
      setError(e?.response?.data?.error || 'Konnte Daten nicht laden');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isPrivileged) load();
  }, [isPrivileged]);

  const openAssign = (trainee) => {
    setSelectedTrainee(trainee);
    setSelectedMentorId('');
    setForceAssign(false);
  };

  const submitAssign = async () => {
    if (!selectedTrainee || !selectedMentorId) return;
    try {
      await api.post('/admin/mentor-mappings', {
        mentorId: Number(selectedMentorId),
        traineeId: selectedTrainee.id,
        // Force-Assign nur für Admins erlaubt; Backend prüft zusätzlich
        force: !!forceAssign,
      });
      setSelectedTrainee(null);
      setSelectedMentorId('');
      setForceAssign(false);
      await load();
    } catch (e) {
      setError(e?.response?.data?.error || 'Zuordnung fehlgeschlagen');
    }
  };

  const endAssignment = async (assignmentId) => {
    try {
      await api.post(`/admin/mentor-mappings/${assignmentId}/end`);
      await load();
    } catch (e) {
      setError(e?.response?.data?.error || 'Beenden der Zuordnung fehlgeschlagen');
    }
  };

  const toggleMentorExpanded = (mentorId) => {
    setExpandedMentors(prev => ({
      ...prev,
      [mentorId]: !prev[mentorId],
    }));
  };

  if (!isPrivileged) {
    return (
      <div className="home-page" style={{ padding: '40px 20px', textAlign: 'center' }}>
        <h2 style={{ marginTop: 0 }}>Kein Zugriff</h2>
        <p style={{ maxWidth: 640, margin: '12px auto', lineHeight: 1.5 }}>Diese Seite ist nur für Moderation und Administration sichtbar.</p>
      </div>
    );
  }

  return (
    <div className="home-page">
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Anwärter - Mentoren Zuordnung</h2>
        <p className="hero-desc" style={{ textAlign: 'center', margin:'0 auto 24px', maxWidth:760 }}>Wer betreut wen? Übersicht & Zuordnung.</p>
        <p style={{ textAlign: 'center', maxWidth: 780, margin: '0 auto', color: '#D4D8DF' }}>
          Hier kannst du Anwärter aktiv Mentoren zuordnen. Jeder Mentor kann maximal zwei Anwärter gleichzeitig betreuen, ein Anwärter hat genau einen aktiven Mentor. Beendete Zuordnungen bleiben für die Nachverfolgung erhalten.
        </p>
      </section>

      <section style={{ width: '100%', maxWidth: 1200, margin: '0 auto', padding: '0 16px 60px', color: '#fff' }}>
        {error && (
          <div style={{ marginBottom: 16, padding: 12, borderRadius: 8, background: 'rgba(220,38,38,0.15)', border: '1px solid rgba(248,113,113,0.6)', color: '#fecaca' }}>
            {error}
          </div>
        )}
        {loading ? (
          <p>Lade Daten...</p>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1.3fr) minmax(0,1fr)', gap: 20, alignItems: 'flex-start' }}>
            <div className="highlight-card" style={{ padding: 20 }}>
              <h2 className="highlight-title">Anwärter</h2>
              <p style={{ color: '#cbd5e1', lineHeight: 1.5, fontSize: 14 }}>Liste aller aktiven Anwärter mit ihrem aktuellen Mentor (falls vorhanden).</p>
              <div style={{ marginTop: 10, maxHeight: 480, overflow: 'auto' }}>
                {data.trainees.length === 0 ? (
                  <p style={{ color: '#9ca3af', fontSize: 14 }}>Aktuell sind keine Anwärter vorhanden.</p>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                      <tr style={{ textAlign: 'left', borderBottom: '1px solid rgba(255,255,255,0.12)' }}>
                        <th style={{ padding: '4px 6px' }}>Anwärter</th>
                        <th style={{ padding: '4px 6px' }}>Seit</th>
                        <th style={{ padding: '4px 6px' }}>Geworben durch</th>
                        <th style={{ padding: '4px 6px' }}>Mentor</th>
                        <th style={{ padding: '4px 6px' }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.trainees.map(t => {
                        const a = t.activeAssignment;
                        const mentor = a ? data.mentors.find(m => m.id === a.mentorId) : null;
                        return (
                          <tr key={t.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                            <td style={{ padding: '4px 6px' }}>
                              <div style={{ fontWeight: 600 }}>{t.displayName || t.username}</div>
                              <div style={{ fontSize: 11, opacity: 0.7 }}>{t.username}</div>
                            </td>
                            <td style={{ padding: '4px 6px', fontSize: 12 }}>{t.createdAt ? new Date(t.createdAt).toLocaleDateString() : '-'}</td>
                            <td style={{ padding: '4px 6px', fontSize: 12 }}>
                              {t.referrer
                                ? (t.referrer.displayName || t.referrer.username)
                                : <span style={{ opacity: 0.6 }}>–</span>}
                            </td>
                            <td style={{ padding: '4px 6px', fontSize: 12 }}>
                              {mentor ? (
                                <span>{mentor.displayName || mentor.username}</span>
                              ) : (
                                <span style={{ opacity: 0.6 }}>kein Mentor zugeordnet</span>
                              )}
                            </td>
                            <td style={{ padding: '4px 6px', textAlign: 'right' }}>
                              <button
                                onClick={() => openAssign(t)}
                                style={{
                                  padding: '4px 8px',
                                  borderRadius: 6,
                                  border: 'none',
                                  cursor: 'pointer',
                                  fontSize: 12,
                                  background: '#2563eb',
                                  color: '#fff',
                                }}
                              >
                                {t.activeAssignment ? 'Mentor wechseln' : 'Mentor zuordnen'}
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>

            <div className="highlight-card" style={{ padding: 20 }}>
              <h2 className="highlight-title">Mentoren</h2>
              <p style={{ color: '#cbd5e1', lineHeight: 1.5, fontSize: 14 }}>Maximal zwei aktive Anwärter pro Mentor.</p>
              <div style={{ marginTop: 10, maxHeight: 480, overflow: 'auto' }}>
                {data.mentors.length === 0 ? (
                  <p style={{ color: '#9ca3af', fontSize: 14 }}>Aktuell sind keine Mentoren vorhanden.</p>
                ) : (
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gap: 10 }}>
                    {data.mentors.map(m => {
                      const isExpanded = !!expandedMentors[m.id];
                      const historyCount = Array.isArray(m.historyAssignments) ? m.historyAssignments.length : 0;
                      const overLimit = m.activeCount > 2;
                      return (
                      <li key={m.id} style={{ border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, padding: 10 }}>
                        <div
                          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6, cursor: historyCount > 0 ? 'pointer' : 'default' }}
                          onClick={() => historyCount > 0 && toggleMentorExpanded(m.id)}
                        >
                          <div>
                            <div style={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
                              <span>{m.displayName || m.username}</span>
                              {historyCount > 0 && (
                                <span style={{ fontSize: 11, opacity: 0.8 }}>
                                  ({historyCount} frühere Anwärter)
                                </span>
                              )}
                            </div>
                            <div style={{ fontSize: 11, opacity: 0.7 }}>{m.username}</div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
                            <span
                              style={{
                                padding: '2px 8px',
                                borderRadius: 999,
                                background: overLimit ? 'rgba(248,113,113,0.20)' : 'rgba(16,185,129,0.18)',
                                color: overLimit ? '#fecaca' : '#6ee7b7',
                                fontWeight: overLimit ? 600 : 400,
                              }}
                              title={overLimit ? 'Überbelegung (Admin-Override)' : undefined}
                            >
                              {m.activeCount} / 2 Anwärter
                            </span>
                            {historyCount > 0 && (
                              <span style={{ fontSize: 16, opacity: 0.9 }}>
                                {isExpanded ? '▾' : '▸'}
                              </span>
                            )}
                          </div>
                        </div>
                        <div style={{ fontSize: 12, color: '#cbd5e1' }}>
                          {(!m.activeAssignments || m.activeAssignments.length === 0) ? (
                            <div style={{ opacity: 0.7 }}>Keine aktiven Anwärter zugeordnet.</div>
                          ) : (
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gap: 4 }}>
                              {m.activeAssignments.map(a => {
                                const trainee = data.trainees.find(t => t.id === a.traineeId);
                                return (
                                  <li key={a.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>{trainee ? (trainee.displayName || trainee.username) : `User #${a.traineeId}`}</span>
                                    <button
                                      onClick={() => endAssignment(a.id)}
                                      style={{
                                        padding: '2px 6px',
                                        borderRadius: 6,
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: 11,
                                        background: 'rgba(248,113,113,0.18)',
                                        color: '#fecaca',
                                      }}
                                    >
                                      Zuordnung beenden
                                    </button>
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                          {isExpanded && m.historyAssignments && m.historyAssignments.length > 0 && (
                            <div style={{ marginTop: 8, borderTop: '1px solid rgba(148,163,184,0.4)', paddingTop: 6 }}>
                              <div style={{ fontSize: 11, opacity: 0.8, marginBottom: 2 }}>Ehemalige Anwärter:</div>
                              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gap: 3 }}>
                                {m.historyAssignments.map(a => {
                                  const traineeName = a.trainee ? (a.trainee.displayName || a.trainee.username) : `User #${a.traineeId}`;
                                  return (
                                    <li key={`hist-${a.id}`} style={{ fontSize: 11, opacity: 0.8 }}>
                                      {traineeName} (
                                      {a.assignedAt ? new Date(a.assignedAt).toLocaleDateString() : '?'} – {a.endedAt ? new Date(a.endedAt).toLocaleDateString() : '?'})
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          )}
                        </div>
                      </li>
                    );
                    })}
                  </ul>
                )}
              </div>
            </div>
          </div>
        )}

        {selectedTrainee && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 50,
            }}
          >
            <div style={{ background: '#020617', borderRadius: 12, padding: 20, width: '100%', maxWidth: 420, border: '1px solid rgba(148,163,184,0.5)' }}>
              <h3 style={{ marginTop: 0, marginBottom: 8 }}>Mentor zuordnen</h3>
              <p style={{ fontSize: 13, color: '#cbd5e1', marginBottom: 10 }}>
                Anwärter: <strong>{selectedTrainee.displayName || selectedTrainee.username}</strong>
              </p>
              <label style={{ fontSize: 13, color: '#e5e7eb' }}>
                Mentor auswählen
                <select
                  value={selectedMentorId}
                  onChange={e => setSelectedMentorId(e.target.value)}
                  style={{ width: '100%', marginTop: 6, marginBottom: 12, padding: '6px 8px', borderRadius: 6, border: '1px solid #4b5563', background: '#020617', color: '#e5e7eb' }}
                >
                  <option value="">– bitte wählen –</option>
                  {data.mentors.map(m => (
                    <option
                      key={m.id}
                      value={m.id}
                      disabled={!user?.roles?.includes('admin') && m.activeCount >= 2}
                    >
                      {m.displayName || m.username} ({m.activeCount}/2)
                    </option>
                  ))}
                </select>
              </label>
              {user?.roles?.includes('admin') && (
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#fecaca', marginBottom: 12 }}>
                  <input
                    type="checkbox"
                    checked={forceAssign}
                    onChange={e => setForceAssign(e.target.checked)}
                  />
                  <span>
                    Slot-Limit ignorieren (Admin-Override, Mentor kann mehr als 2 Anwärter haben)
                  </span>
                </label>
              )}
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <button
                  onClick={() => { setSelectedTrainee(null); setSelectedMentorId(''); }}
                  style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #4b5563', background: 'transparent', color: '#e5e7eb', cursor: 'pointer', fontSize: 13 }}
                >
                  Abbrechen
                </button>
                <button
                  onClick={submitAssign}
                  disabled={!selectedMentorId}
                  style={{ padding: '6px 10px', borderRadius: 6, border: 'none', background: '#22c55e', color: '#022c22', cursor: selectedMentorId ? 'pointer' : 'not-allowed', fontSize: 13, fontWeight: 600 }}
                >
                  Speichern
                </button>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
